import styled from 'styled-components';

const Container = styled.div`
  width: 220px;
  padding: 8px 0 8px 16px;
`;

export { Container };
